import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { AccordionEvent } from 'src/app/shared/accordion/accordion.event';

@Component({
  selector: 'app-accordion-item-head',
  templateUrl: './accordion-item-head.component.html',
  styleUrls: ['./accordion-item-head.component.scss']
})
export class AccordionItemHeadComponent extends AccordionEvent implements OnInit {
  @Output() clickHead = new EventEmitter<boolean>();

  constructor() { super(); }

  ngOnInit() {
  }

  openContent() {
    this._isShowContent = !this._isShowContent;
    this.clickHead.emit(this._isShowContent);
  }
}
